// 计算并设置 rem
const baseWidth = 1920
function setRem() {
  const scale = document.documentElement.clientWidth / baseWidth
  document.documentElement.style.fontSize = scale * 100 + 'px'
}

// 还原
function clearRem() {
  document.documentElement.style.fontSize = ''
}

let resizeHandler = null

export default {
  mounted() {
    setRem()
    resizeHandler = () => setRem()
    window.addEventListener('resize', resizeHandler)
  },
  beforeDestroy() {
    clearRem()
    window.removeEventListener('resize', resizeHandler)
    resizeHandler = null
  }
}